import { useRef } from 'react';
import type { CompulsoryInsurancePenaltyTicketSummary } from '#/components/ui/tickets/compulsory-insurance-penalty/model';

export type ChargeFailDialogConfirmValue = { afterDays: number };

export type ChargeFailDialogRef = {
  confirm: (
    ticket: CompulsoryInsurancePenaltyTicketSummary,
    amount: number,
  ) => Promise<ChargeFailDialogConfirmValue | undefined>;
  days: number | undefined;
};

export const useChargeFailDialog = () => {
  const modalRef = useRef<ChargeFailDialogRef>(null);
  const open = (
    ticket: CompulsoryInsurancePenaltyTicketSummary,
    amount: number,
  ) => modalRef.current?.confirm(ticket, amount);
  return { props: { modalRef }, open };
};
